import { action } from "mobx";
import { postSelectedTreatmentOption } from "services/selectedTreatmentOptionService";
import { SelectedTreatmentPayloadType } from "../domain/selectedTreatments";
import { StoreBase } from "./storeBase";

export class SelectedTreatmentPostStore extends StoreBase<SelectedTreatmentPayloadType> {
  constructor() {
    super(() => null);
  }

  @action
  postSelectedTreatments(
    selectedTreatmentPayload: SelectedTreatmentPayloadType
  ) {
    return this.updateData(() =>
      postSelectedTreatmentOption(selectedTreatmentPayload)
    );
  }
}
